import { TableCell } from "@tiptap/extension-table";


const CustomTableCell = TableCell.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                // Customize the HTML parsing
                parseHTML: element => element.getAttribute('class'),
                // … and customize the HTML rendering
                renderHTML: attributes => {
                    if (attributes.class) {
                        return {
                            'class': attributes.class
                        }
                    }
                },
            },
            style: {
                default: "height: 40px;",
                // Customize the HTML parsing
                parseHTML: element => element.getAttribute('style'),
                // … and customize the HTML rendering
                renderHTML: attributes => {
                    if (attributes.style) {
                        return {
                            'style': attributes.style
                        }
                    }
                },
            }
        }
    },
});


export default CustomTableCell;